import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axiosInstance from "../Help/AxiosLogicInstance";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Images from "../images";
import LazyImg from "./LazyImg";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    // Set page title
    document.title = "Change Password - MedEngage";

    // Check if user is logged in
    const studentId = localStorage.getItem("StudentId");
    if (!studentId) {
      toast.error("Please login to change your password");
      navigate("/");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Password validation
    if (newPassword.length < 6) {
      toast.error("New password must be at least 6 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }

    const studentId = localStorage.getItem("StudentId");
    setLoading(true);

    try {
      // IMPORTANT: Sending the data directly without the 'request' wrapper
      // since the error suggests the API is looking for fields directly
      const res = await axiosInstance.post(
        "/api/Student/ChangeStudentPassword",
        {
          studentId: studentId.toString(), // Convert to string explicitly
          CurrentPassword: oldPassword,
          NewPassword: newPassword,
          ConfirmPassword: confirmPassword,
          Emailid: "student@example.com",
          timestamp:"", // Provide a non-empty value
        }
      );

      console.log("Response:", res.data);

      if (res.data.Status === "200") {
        toast.success("Password updated successfully!");
        navigate("/");
      } else {
        toast.error(res.data.Message || "Password update failed.");
      }
    } catch (err) {
      console.error(
        "Password change error:",
        err.response?.data || err.message
      );
      toast.error(
        err.response?.data?.Message || "Server error. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <section className="ul-about password-space">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="container my-5">
              <div className="card shadow-sm rounded-4 overflow-hidden">
                <div className="row g-0 align-items-center">
                  {/* Left Side - Image */}
                  <div className="col-lg-6 d-none d-lg-block">
                    <div className="position-relative h-100">
                      <LazyImg
                        src={Images.Password}
                        alt="Security illustration for change password"
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                        loading="eager"
                      />
                      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"></div>
                    </div>
                  </div>

                  {/* Right Side - Form */}
                  <div className="col-lg-6 col-12 p-4">
                    <h3
                      className="text-center mb-4"
                      style={{ color: "#00984A" }}
                    >
                      Change Password
                    </h3>
                    <form onSubmit={handleSubmit}>
                      {/* Old Password */}
                      <div className="mb-3">
                        <label className="form-label">
                          Old Password<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center border rounded">
                          <input
                            type={showOld ? "text" : "password"}
                            className="form-control border-0 flex-grow-1"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            required
                            disabled={loading}
                            style={{ paddingRight: "2.5rem" }}
                          />
                          <span
                            className="px-2 cursor-pointer"
                            onClick={() => setShowOld(!showOld)}
                          >
                            <i
                              className={`fa ${
                                showOld ? "fa-eye-slash" : "fa-eye"
                              }`}
                            ></i>
                          </span>
                        </div>
                      </div>

                      {/* New Password */}
                      <div className="mb-3">
                        <label className="form-label">
                          New Password<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center border rounded">
                          <input
                            type={showNew ? "text" : "password"}
                            className="form-control border-0 flex-grow-1"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            minLength="6"
                            disabled={loading}
                            style={{ paddingRight: "2.5rem" }}
                          />
                          <span
                            className="px-2 cursor-pointer"
                            onClick={() => setShowNew(!showNew)}
                          >
                            <i
                              className={`fa ${
                                showNew ? "fa-eye-slash" : "fa-eye"
                              }`}
                            ></i>
                          </span>
                        </div>
                      </div>

                      {/* Confirm New Password */}
                      <div className="mb-3">
                        <label className="form-label">
                          Confirm New Password
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center border rounded">
                          <input
                            type={showConfirm ? "text" : "password"}
                            className="form-control border-0 flex-grow-1"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            disabled={loading}
                            style={{ paddingRight: "2.5rem" }}
                          />
                          <span
                            className="px-2 cursor-pointer"
                            onClick={() => setShowConfirm(!showConfirm)}
                          >
                            <i
                              className={`fa ${
                                showConfirm ? "fa-eye-slash" : "fa-eye"
                              }`}
                            ></i>
                          </span>
                        </div>
                      </div>

                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn-view"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Updating...
                            </>
                          ) : (
                            "Update Password"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ChangePassword;
